
import React from 'react';
import { Link } from "react-router-dom";
import Header from '../core/Header';
import backgroundImage from '../assets/hero/atelier-jenny-homepage.jpg';

const Hero = () => {
  return (
    <div>
      <div
        className="relative w-full h-screen bg-cover bg-center "
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-15"></div>

        {/* Header */}
        <Header />

        {/* Main Content */}
        <div className="relative top-20 z-10 flex flex-col items-center justify-center h-full text-white text-center px-4">
          <h1 className="text-4xl md:text-5xl lg:text-4xl font-serif font-normal mb-4 tracking-wider">
            ΧΕΙΡΟΠΟΙΗΤΑ ΝΥΦΙΚΑ ΦΟΡΕΜΑΤΑ ΣΧΕΔΙΑΣΜΕΝΑ ΓΙΑ ΚΑΘΕ ΓΥΝΑΙΚΑ
          </h1>
          <p className="text-xl md:text-2xl mb-6 font-serif">
            Sur Mesure
          </p>
          <button className="px-8 py-4 border border-white text-white hover:bg-white hover:text-black transition duration-300">
           <Link to="/nifika">ΝΥΦΙΚΑ</Link>
          </button>
        </div>
      </div>
    
    </div>
  );
};

export default Hero;
